"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("./Box"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var mw = function mw(em) {
  return em - 0.01;
};

var breakpoints = function breakpoints(props) {
  return {
    xs: "@media screen and (max-width: ".concat(mw(props.theme.breakpoints[0]), "em)"),
    sm: "@media screen and (min-width: ".concat(props.theme.breakpoints[0], "em) and (max-width: ").concat(mw(props.theme.breakpoints[1]), "em)"),
    md: "@media screen and (min-width: ".concat(props.theme.breakpoints[1], "em) and (max-width: ").concat(mw(props.theme.breakpoints[2]), "em)"),
    lg: "@media screen and (min-width: ".concat(props.theme.breakpoints[2], "em) and (max-width: ").concat(mw(props.theme.breakpoints[3]), "em)"),
    xl: "@media screen and (min-width: ".concat(props.theme.breakpoints[3], "em)")
  };
};

var hidden = function hidden(key) {
  return function (props) {
    return props[key] ? _defineProperty({}, breakpoints(props)[key], {
      display: 'none'
    }) : null;
  };
};

var Hide = (0, _styledComponents["default"])(_Box["default"])([], hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'));
Hide.displayName = 'Hide';
Hide.propTypes = {
  xs: _propTypes["default"].bool,
  sm: _propTypes["default"].bool,
  md: _propTypes["default"].bool,
  lg: _propTypes["default"].bool,
  xl: _propTypes["default"].bool
};
Hide.defaultProps = {
  theme: _theme["default"]
};
var _default = Hide;
exports["default"] = _default;